<template lang="html">
  <div class="news">
    <h1>Híreink, eseményeink</h1>
    <p>Tájékozódjon
      <a href="https://facebook.com" target="_blank">facebook-oldalunkról</a> is!
    </p>
    <div v-if="upcomingEvents && upcomingEvents.length>0">
      <h2>Közelgő események</h2>
      <NewsList :news="upcomingEvents" />
    </div>

    <div v-if="otherNews  && otherNews.length>0" class="">
      <h3>Egyéb híreink</h3>
      <NewsList :news="otherNews" />
    </div>

  </div>
</template>

<script>
import NewsList from '@/components/News/NewsList.vue'

export default {
  data(){
    return{

    }
  },
  computed: {
    news(){
      return this.$store.getters.allNews
    },
    upcomingEvents(){
      if(this.news){
        return this.news.filter(n=>new Date(n.date_of_event)>=new Date())
      }
    },
    otherNews(){
      if(this.upcomingEvents){
        let difference = this.news.filter(x => !this.upcomingEvents.includes(x));
        return difference;
      }
    },
  },
  created(){
    this.$store.dispatch('setNews');
  },
  components:{
    NewsList,
  },
}
</script>

<style lang="scss" scoped>
.news{
  text-align: center;

  a:link,
  a:visited{
    text-decoration: none;
    color: 	rgb(139,69,19);
    cursor: pointer;
    text-decoration: none;

    &:hover{
      color: maroon;
    }
  }
}
</style>
